const mobileMenu = document.querySelector("[data-mobile-menu]");
const mobileMenuIcon = document.querySelector("[data-hamburger-button]");
const mobileMenuButton = document.querySelector(
  ".navbar-one__menu-icon-wrapper"
);
const mobileNavMenuItems = mobileMenu?.querySelectorAll(
  ".navbar__menu .menu-item-has-children > a"
);
const mobileNavBackButtons = mobileMenu?.querySelectorAll(
  ".navbar__menu .menu-item-type-back > a"
);

const mobileNavBackButtonsInner = mobileMenu?.querySelectorAll(
  ".navbar__menu .menu-item-type-back-inner > a"
);
const siteHeader = document.querySelector(".site-header");

const subMenuInnerList = document.querySelectorAll('.sub-menu--inner')

const toggleAttribute = (element, attribute, condition) => {
  element.toggleAttribute(attribute, condition);
};

const toggleDisplay = () => {
  const menu = document.querySelector("[data-mobile-menu]");
  if (menu.hasAttribute("data-open")) {
    siteHeader.classList.add("mega-menu-open");
    siteHeader.classList.add("mobile-menu-open");
  } else {
    siteHeader.classList.remove("mega-menu-open");
    siteHeader.classList.remove("mobile-menu-open");
  }

  if (mobileMenuIcon.classList.contains("menu-open")) {
    mobileMenuIcon.classList.remove("menu-open");
  } else {
    const searchIcon = document.querySelector(".navbar-one__search-btn")
    mobileMenuIcon.classList.add("menu-open");
    document.body.classList.remove("navSearchOpen");
    searchIcon.classList.remove("close");
  }
};

const closeAllSubMenus = () => {
  // Find all sub-menus
  const allSubMenus = mobileMenu?.querySelectorAll('.sub-menu');
  // Remove data-open attribute from all sub-menus
  allSubMenus?.forEach(submenu => {
    submenu.removeAttribute('data-open');
  });
  
  // Find all expanded items
  const expandedItems = mobileMenu?.querySelectorAll('.menu-item-has-children');
  // Remove data-expanded attribute from all items
  expandedItems?.forEach(item => {
    item.removeAttribute('data-expanded');
  });
};

const toggleMenu = (open) => {
  toggleAttribute(mobileMenu, "data-open", open);
  toggleAttribute(document.body, "tabindex", open ? "-1" : null);
  toggleDisplay();
  
  if (open) {
    // Store current scroll position
    document.body.style.top = `-${window.scrollY}px`;
    document.body.classList.add("overflow-hidden");
  } else {
    // Restore scroll position
    const scrollY = document.body.style.top;
    document.body.classList.remove("overflow-hidden");
    document.body.style.top = '';
    
    // Safely restore scroll position
    try {
      const scrollPosition = parseInt(scrollY || '0') * -1;
      if (!isNaN(scrollPosition)) {
        window.scrollTo(0, scrollPosition);
      }
    } catch (error) {
      console.warn('Could not restore scroll position:', error);
    }
  }

  if (!open) {
    closeAllSubMenus();
  }
};

const toggleMenuItem = (itemLink) => {
  const menu = itemLink.closest(".navbar__menu, .sub-menu");
  const item = itemLink.closest(".menu-item-has-children");
  const subMenu = item.querySelector(":scope > .sub-menu");
  const isOpen = subMenu.dataset.open;

  const backLink = subMenu.querySelector(
    ".back-menu-item-link-text"
  );

  const backLinkInner = subMenu.querySelector(
    ".back-menu-item-inner-link-text"
  );

  if (!isOpen) {
    menu
      .querySelectorAll(".menu-item-has-children > .sub-menu")
      .forEach((otherItemLink) => {
        const otherItem = otherItemLink.closest(".menu-item-has-children");
        const subMenu = otherItem.querySelector(".sub-menu");
        toggleAttribute(subMenu);

        if (backLink){
          backLink.innerHTML = itemLink.innerHTML;
        }

        if (backLinkInner){
          backLinkInner.innerHTML = itemLink.innerHTML;
        }
      });

    item.setAttribute("data-expanded", true);
    subMenu.setAttribute("data-open", true);
  } else {
    item.removeAttribute("data-expanded");
    subMenu.removeAttribute("data-open");
  }
};

mobileNavMenuItems?.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.preventDefault();
    toggleMenuItem(item);
  });
});

[mobileMenuButton].forEach((button, index) => {
  button?.addEventListener("click", () => {
    if (index === 0) {
      // Hamburger button
      const isOpen = mobileMenu.hasAttribute("data-open");
      toggleMenu(!isOpen);
    } else {
      // Close button
      closeAllSubMenus();
      toggleMenu(false);
    }
  });
});

mobileNavBackButtons?.forEach((button) => {
  button.addEventListener("click", () => {
    const subMenu = button.closest(".sub-menu");
    if (subMenu) {
      subMenu.removeAttribute("data-open");
    }
  });
});

mobileNavBackButtonsInner?.forEach((button) => {
  button.addEventListener("click", () => {
    const subMenuInner = button.closest(".sub-menu");
    if (subMenuInner) {
      subMenuInner.removeAttribute("data-open");
    }
  });
});

// open sub menu if only item is dropdown 
const openIfOnlyItem = () => {
  subMenuInnerList.forEach((item) => {
    const menuItem = item.querySelectorAll(':scope > .menu-item')
    if (menuItem.length === 2 && menuItem?.[1].classList.contains('menu-item-has-children')) {
      const soloList = menuItem[1].querySelector('.sub-menu')
      menuItem[1].setAttribute("data-expanded", true);
      soloList.setAttribute("data-open", true);
    }
  })
}

// Function to apply open submenu height to primary navigation
const applyOpenSubmenuHeightToPrimaryMenu = () => {
  const openSubmenus = document.querySelectorAll('.sub-menu[data-open="true"]');
  const primaryMenu = document.querySelector('.navbar__menu');
  
  if (openSubmenus.length > 0 && primaryMenu) {
    const openSubmenu = openSubmenus[0];
    const submenuContentHeight = openSubmenu.scrollHeight;
    primaryMenu.style.height = `${submenuContentHeight}px`;
    return submenuContentHeight;
  } else if (primaryMenu) {
    primaryMenu.style.height = '100%';
  }
};

// Function to detect and apply submenu height changes
const detectOpenSubmenu = () => {
  const openSubmenus = document.querySelectorAll('.sub-menu[data-open="true"]');
  
  if (openSubmenus.length > 0) {
    applyOpenSubmenuHeightToPrimaryMenu();
  } else {
    applyOpenSubmenuHeightToPrimaryMenu();
  }
};

// Function to monitor submenu state changes
const monitorSubmenuChanges = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-open') {
        detectOpenSubmenu();
      }
    });
  });
  
  const subMenus = document.querySelectorAll('.sub-menu');
  subMenus.forEach(subMenu => {
    observer.observe(subMenu, { 
      attributes: true, 
      attributeFilter: ['data-open'] 
    });
  });
  
  detectOpenSubmenu();
};

if (document.readyState !== "loading") {
  openIfOnlyItem();
  monitorSubmenuChanges();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    openIfOnlyItem();
    monitorSubmenuChanges();
  });
}